import React from 'react';

import Test from '@components/Test';

function SecondPage() {
  return <Test />;
}

export default SecondPage;
